import React from 'react';
import AddPageTab from './AddPageTab'
import DetailPageTab from './DetailPageTab'


interface propsTypes {
  isEditable?: void | any,
  cancelEditable?: void | any,
  disableTabPanes?: void | any,
  detail?: any,
  cancelAndSave?: void | any,
  tableCurrentData?: any

}
const DetailPageInfo = (props: propsTypes) => {
  return (<>
    {!props.detail ? <AddPageTab cancelAndSave={props.cancelAndSave} /> : <DetailPageTab disableTabPanes={props.disableTabPanes} cancelAndSave={props.cancelAndSave} tableCurrentData={props.tableCurrentData} isEditable={props.isEditable} cancelEditable={props.cancelEditable} />}



  </>);
}
export default DetailPageInfo;